import CustomButton from "components/button/custom_button";
import InputField from "components/fields/InputField";
import { useState } from "react";
import { useDispatch } from "react-redux";
import { changeUserPassword } from "services/users/userAddEditSlice";

export default function PasswordChangeModal(props) {
  const dispatch = useDispatch();
  const { id, setShowModal } = props;
  const [values, setValues] = useState({
    newPassword: "",
    rePassword: "",
  });

  const inputs = [
    {
      id: "p1",
      name: "newPassword",
      type: "password",
      placeholder: "Шинэ нууц үг",
      errorMessage: "Шинэ нууц үгээ оруулна уу! 5-аас дээш тэмдэгт байх ёстой.",
      label: "Шинэ нууц үг",
      pattern: "^.{5,10}$",
      required: true,
    },
    {
      id: "p2",
      name: "rePassword",
      type: "password",
      placeholder: "Нууц үг давтах",
      errorMessage: "",
      label: "Нууц үг давтах",
      required: true,
    },
  ];

  const onChange = (e) => {
    setValues({ ...values, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    if (!e.preventDefault() && values["rePassword"] === values["newPassword"]) {
      var data = {
        id: id,
        password: values["newPassword"],
      };
      dispatch(changeUserPassword(data)).then((response) => {
        if (response.payload) {
          if (response.payload.status) {
            setShowModal(false);
          }
        }
      });
    }
  };
  return (
    <div>
      <div className="fixed inset-0 z-50 flex items-center justify-center overflow-y-auto overflow-x-hidden outline-none focus:outline-none ">
        <div className="relative my-6 mx-auto w-auto max-w-3xl">
          <div className="relative flex w-full flex-col rounded-lg border-0 bg-white p-10 shadow-lg outline-none focus:outline-none">
            <form onSubmit={handleSubmit}>
              <div className="grid grid-cols-2">
                <h3 className="text-2xl font-semibold">
                  Хэрэглэгчийн нууц үг засах
                </h3>
                <button
                  className="float-right ml-auto border-0 p-1 text-3xl font-semibold leading-none text-black outline-none focus:outline-none"
                  onClick={() => setShowModal(false)}
                >
                  ×
                </button>
              </div>
              {/*body*/}
              <div className="relative flex-auto overflow-x-hidden p-6 ">
                {/* USER INPUTS  */}
                {inputs.map((input, index) => (
                  <InputField
                    key={"key" + input.id}
                    id={input.id}
                    {...input}
                    value={values[input.name]}
                    onChange={onChange}
                  />
                ))}

                {values["rePassword"] !== values["newPassword"] ? (
                  <span
                    style={{
                      fontSize: "12px",
                      padding: "3px",
                      color: "red",
                    }}
                  >
                    Нууц үг таарахгүй байна
                  </span>
                ) : null}
              </div>
              {/*footer*/}
              <div className="border-slate-200 flex items-center justify-end rounded-b border-t border-solid p-6">
                <button
                  className="background-transparent mr-1 mb-1 px-6 py-2 text-sm font-bold uppercase text-red-500 outline-none transition-all duration-150 ease-linear focus:outline-none"
                  type="button"
                  onClick={() => setShowModal(false)}
                >
                  Хаах
                </button>

                <CustomButton text="Хадгалах" type="submit" className="mr-3" />
              </div>
            </form>
          </div>
        </div>
      </div>
      <div className="fixed inset-0 z-40 bg-black opacity-25"></div>
    </div>
  );
}
